import React from 'react';
import {Box, Button, Card, CardContent, Stack, Typography,} from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import {useNavigate} from 'react-router-dom';


function LineupDone({groupId, setGroupId, group, setGroup}) {
    const navigate = useNavigate();

    const handleHomeClick = () => {
        navigate('/');
        localStorage.removeItem('groupId'); //remove groupId from local storage
    };

    const handleLineUpClick = () => {
        localStorage.removeItem('groupId'); //remove groupId from local storage
        setGroupId(null);
    };

    let content;

    switch (group.status) {
        case "CANCELLED":
            content = (
                <Typography align="center"
                            sx={{fontSize: '1.2rem', fontWeight: 500, padding: '10px 5px 10px 5px'}}>
                    Your spot in the line has been cancelled.
                </Typography>
            );
            break;
        case "COMPLETE":
            content = (
                <>
                    <Typography align="center"
                                sx={{fontSize: '1.2rem', fontWeight: 500, padding: '10px 5px 5px 5px'}}>
                        You have completed your observatory visit.
                    </Typography>
                    <Typography align="center"
                                sx={{fontSize: '1rem', fontWeight: 400, padding: '0px 3px 10px 3px'}}>
                        Thank you for coming! Feel free to line-up again.
                    </Typography>
                </>
            );
            break;
        case "INSIDE":
            content = (
                <>
                    <Typography align="center"
                                sx={{fontSize: '1.2rem', fontWeight: 500, padding: '10px 5px 5px 5px'}}>
                        You have been admitted into the observatory.
                    </Typography>
                    <Typography align="center"
                                sx={{fontSize: '1rem', fontWeight: 400, padding: '0px 3px 10px 3px'}}>
                        Please avoid shining any bright lights and enjoy your visit!
                    </Typography>
                </>
            );
            break;
        default:
            content = (
                <Typography align="center"
                            sx={{fontSize: '1.2rem', fontWeight: 500, padding: '10px 5px 10px 5px'}}>
                    Unexpected Status.
                </Typography>
            );
    }

    return (
        <Card elevation={9} rounded="true">
            <CardContent>
                {content}
                <Box sx={{
                    padding: '15px 25px 10px 25px',
                    maxWidth: '500px',
                    margin: 'auto',
                    justifyContent: 'center'
                }}>
                    <Stack spacing={3}>
                        <Button variant="outlined"
                                endIcon={<RocketLaunchIcon/>}
                                size="large"
                                sx={{fontWeight: '700'}}
                                onClick={handleLineUpClick}>
                            Line up again
                        </Button>
                        <Button variant="outlined"
                                endIcon={<HomeIcon/>}
                                size="large"
                                sx={{fontWeight: '700'}}
                                onClick={handleHomeClick}>
                            Return Home
                        </Button>
                    </Stack>
                </Box>
            </CardContent>
        </Card>

    )
}

export default LineupDone;
